import collectionReducer from '../collectionReducer';

export default collectionReducer({
    collectionActionName: 'CLUSTER_TYPES',
    itemActionName: 'CLUSTER_TYPE',
});
